import type { ArrayElement } from '@lib/types/arrayElement'
import type { PatientApplyProfileData } from '@modules/patientApplyProfile/helpers/PatientApplyProfileData'
import type { SurveyQuestion } from './types'

const hasSelectedTrialLocationIdMatch = (
  datum: ArrayElement<PatientApplyProfileData>,
) => datum.conceptName === 'pickedTrialLocation' && datum.conceptValue

const hasSelectedTrialLocationIdPresent = (data: PatientApplyProfileData) =>
  data.some(hasSelectedTrialLocationIdMatch)

export const SurveyQuestionsLocations: SurveyQuestion[] = [
  {
    category: 'locations',
    id: 'locations',
    questionText: "Select the site location you're willing to travel to",
    shouldShowQuestionToPatient: hasSelectedTrialLocationIdPresent,
  },
]

export const LocationsAttributes = {
  locations: 'locations' as const,
}
